import { PaymentsModule } from './PaymentsModule';

export const PaymentsVerifiedSlovak = () => {
  return <PaymentsModule flavor={'VerifiedSlovak'} />;
};
